import { Component, Input, OnInit } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute, Params } from '@angular/router';
import { filter, distinctUntilChanged } from 'rxjs/operators';
import { TramiteService } from '../../../services/tramite.service';
import { EntidadDTO } from '../../tramites/models/entidadDTO';
import { Constants } from '../../../constants/constants';
import { TranslateService } from '@ngx-translate/core';
interface Breadcrumb {
  label: string;
  url: string;
}

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
})
export class BreadcrumbComponent implements OnInit {
  breadcrumbs: Breadcrumb[] = [];
  entidades: EntidadDTO[] = [];
  entidadesReemplazo: string[] = [
    'dnda',
    'dimar',
    'ica',
    'sic',
    'supersalud',
    'superfinanciera',
    'supersociedades-mercantiles',
  ];
  @Input() beforeNav: (op: () => void) => Promise<void> | void = op => {
    op();
  };

  tipoUsuario = -1;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private readonly tramiteService: TramiteService,
    private translate: TranslateService
  ) {
    this.tramiteService.listaEntidadesYTramites().subscribe(resp => {
      this.entidades = resp.filter(
        entidad =>
          entidad.Id != Constants.ID_ENTIDAD_SUPER_SOCIEDADES_MERCANTILES
      );
      this.entidades
        .find(entidad => entidad.Id == Constants.ID_ENTIDAD_SUPER_SOCIEDADES)
        ?.Tipo_Tramite.push(
          ...(resp.find(
            entidad =>
              entidad.Id == Constants.ID_ENTIDAD_SUPER_SOCIEDADES_MERCANTILES
          )?.Tipo_Tramite ?? [])
        );
    });
  }

  ngOnInit() {
    const userData = JSON.parse(
      sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE) ?? '{}'
    );
    if (userData && userData.tipoUsuario) {
      this.tipoUsuario = userData.tipoUsuario.Id;
    }
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        distinctUntilChanged()
      )
      .subscribe(() => {
        this.breadcrumbs = this.buildBreadcrumb(this.activatedRoute.root);
      });
  }

  buildBreadcrumb(
    route: ActivatedRoute,
    url: string = '',
    breadcrumbs: Breadcrumb[] = []
  ): Breadcrumb[] {
    const children: ActivatedRoute[] = route.children;

    if (children.length === 0) {
      return breadcrumbs;
    }

    for (const child of children) {
      const routeURL: string = child.snapshot.url
        .map(segment => segment.path)
        .join('/');

      if (routeURL !== '') {
        url += `/${routeURL}`;
      }

      const labelKey = child.snapshot.data['breadcrumb'];
      let label = '';

      if (labelKey) {
        label = this.reemplazarEntidad(labelKey);

        if (label === labelKey) {
          label = labelKey;
        }
      }

      if (label) {
        breadcrumbs.push({ label, url });
      }

      return this.buildBreadcrumb(child, url, breadcrumbs);
    }

    return breadcrumbs;
  }

  isLast(index: number): boolean {
    return index === this.breadcrumbs.length - 1;
  }

  navigate(url: string) {
    const isAbstract = this.tipoUsuario === Constants.ID_TIPO_USUARIO_CIUDADANO || this.tipoUsuario === Constants.ID_TIPO_USUARIO_ABOGADO;
    if(url === "" && isAbstract){
      url = "/procesos/resumen";
    }
    this.beforeNav(() => this.router.navigateByUrl(url));
  }

  reemplazarEntidad(label: string) {
    const labelFormat = label.trim().toLowerCase();
    if(this.entidadesReemplazo.includes(labelFormat)){
      switch (labelFormat) {
        case 'dnda':
          return this.entidades.filter(ent => ent.Id === Constants.ID_ENTIDAD_DNDA)?.[0]?.Acronimo;
        case 'dimar':
          return this.entidades.filter(ent => ent.Id === Constants.ID_ENTIDAD_DIMAR)?.[0]?.Acronimo;
        case 'ica':
          return this.entidades.filter(ent => ent.Id === Constants.ID_ENTIDAD_ICA)?.[0]?.Acronimo;
        case 'sic':
          return this.entidades.filter(ent => ent.Id === Constants.ID_ENTIDAD_SIC)?.[0]?.Acronimo;
        case 'supersalud':
          return this.entidades.filter(ent => ent.Id === Constants.ID_ENTIDAD_SUPERSALUD)?.[0]?.Acronimo;
        case 'superfinanciera':
          return this.entidades.filter(ent => ent.Id === Constants.ID_ENTIDAD_SUPERFINANCIERA)?.[0]?.Acronimo;
        case 'supersociedades-mercantiles':
          return this.entidades.filter(ent => ent.Id === Constants.ID_ENTIDAD_SUPER_SOCIEDADES)?.[0]?.Acronimo;
      }
    }
    return label;
  }
}
